import PropTypes from 'prop-types';

const presetPropTypes = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  description: PropTypes.string,
});

const colorXYPropType = PropTypes.shape({
  r: PropTypes.number,
  g: PropTypes.number,
  b: PropTypes.number,
});

const valuePropTypes = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.bool,
  colorXYPropType,
]);

export const readingPropTypes = PropTypes.shape({
  value: valuePropTypes,
  unit: PropTypes.string,
  measuring_mode: PropTypes.string,
  threshold: PropTypes.object,
});

export const featurePropTypes = PropTypes.shape({
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,

  // For binary
  value_on: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  value_off: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  value_toggle: PropTypes.string,

  // For numeric
  value_min: PropTypes.number,
  value_max: PropTypes.number,
  value_step: PropTypes.number,
  unit: PropTypes.string,

  // For enum
  values: PropTypes.arrayOf(PropTypes.string),

  // For specific types
  features: PropTypes.array,
  presets: PropTypes.arrayOf(presetPropTypes),

  // Reading object
  reading: readingPropTypes,
});

export const actuatorControlPropTypes = {
  feature: featurePropTypes.isRequired,
  value: valuePropTypes,
  mini: PropTypes.bool,
  handleChange: PropTypes.func,
};
